// extracted by mini-css-extract-plugin
export default {"alert":"DownloadDocumentErrorAlert_alert__2D36t","message":"DownloadDocumentErrorAlert_message__5Dw8V"};